"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2018 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license
var BaseNetwork = require('./BaseNetwork');

var _require = require('./Platform'),
    deprecated = _require.deprecated; // ## The NoFlo network coordinator
//
// NoFlo networks consist of processes connected to each other
// via sockets attached from outports to inports.
//
// The role of the network coordinator is to take a graph and
// instantiate all the necessary processes from the designated
// components, attach sockets between them, and handle the sending
// of Initial Information Packets.


var LegacyNetwork = /*#__PURE__*/function (_BaseNetwork) {
  _inherits(LegacyNetwork, _BaseNetwork);

  var _super = _createSuper(LegacyNetwork);

  // All NoFlo networks are instantiated with a graph. Upon instantiation
  // they will load all the needed components, instantiate them, and
  // set up the defined connections and IIPs.
  //
  // The legacy network will also listen to graph changes and modify itself
  // accordingly, including removing connections, adding new nodes,
  // and sending new IIPs.
  function LegacyNetwork(graph) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LegacyNetwork);

    deprecated('noflo.Network construction is deprecated, use noflo.createNetwork');
    return _super.call(this, graph, options);
  }

  _createClass(LegacyNetwork, [{
    key: "connect",
    value: function connect() {
      var _this = this;

      var done = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      _get(_getPrototypeOf(LegacyNetwork.prototype), "connect", this).call(this, function (err) {
        if (err) {
          done(err);
          return;
        }

        _this.subscribeGraph();

        done();
      });
    } // A NoFlo graph may change after network initialization.
    // For this, the legacy network subscribes to the change events
    // from the graph.
    //
    // In graph we talk about nodes and edges. Nodes correspond
    // to NoFlo processes, and edges to connections between them.

  }, {
    key: "subscribeGraph",
    value: function subscribeGraph() {
      var _this2 = this;

      var graphOps = [];
      var processing = false;

      var registerOp = function registerOp(op, details) {
        graphOps.push({
          op: op,
          details: details
        });
      };

      var processOps = function processOps(err) {
        if (err) {
          if (_this2.listeners('process-error').length === 0) {
            throw err;
          }

          _this2.bufferedEmit('process-error', err);
        }

        if (!graphOps.length) {
          processing = false;
          return;
        }

        processing = true;
        var op = graphOps.shift();
        var cb = processOps;

        switch (op.op) {
          case 'renameNode':
            _this2.renameNode(op.details.from, op.details.to, cb);

            break;

          default:
            _this2[op.op](op.details, cb);

        }
      };

      this.graph.on('addNode', function (node) {
        registerOp('addNode', node);

        if (!processing) {
          processOps();
        }
      });
      this.graph.on('removeNode', function (node) {
        registerOp('removeNode', node);

        if (!processing) {
          processOps();
        }
      });
      this.graph.on('renameNode', function (oldId, newId) {
        registerOp('renameNode', {
          from: oldId,
          to: newId
        });

        if (!processing) {
          processOps();
        }
      });
      this.graph.on('addEdge', function (edge) {
        registerOp('addEdge', edge);

        if (!processing) {
          processOps();
        }
      });
      this.graph.on('removeEdge', function (edge) {
        registerOp('removeEdge', edge);

        if (!processing) {
          processOps();
        }
      });
      this.graph.on('addInitial', function (iip) {
        registerOp('addInitial', iip);

        if (!processing) {
          processOps();
        }
      });
      return this.graph.on('removeInitial', function (iip) {
        registerOp('removeInitial', iip);

        if (!processing) {
          processOps();
        }
      });
    }
  }]);

  return LegacyNetwork;
}(BaseNetwork);

exports.Network = LegacyNetwork;